/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userassetslogs.vue?vue&type=template&id=151b1ddd&scoped=true"
import script from "./userassetslogs.vue?vue&type=script&lang=js"
export * from "./userassetslogs.vue?vue&type=script&lang=js"
import style0 from "./userassetslogs.vue?vue&type=style&index=0&id=151b1ddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b1ddd",
  null
  
)

export default component.exports